import { Link, useNavigate } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa6";

const Breadcrumbs = ({ items }) => {
  return (
    <div className="d-flex">
      {items.map((item, index) => {
        const { path, label } = item;
        return (
          <span className="d-flex" key={index}>
            {index !== items.length - 1 ? (
              <Link className="heading-lg" to={path}>
                <h1 className="heading-lg">{label}</h1>
              </Link>
            ) : (
              <h1 className="heading-lg">{label}</h1>
            )}
            {index !== items.length - 1 && (
              <span className="mx-1">
                <FaChevronRight className="breadcrumbs-separator" />
              </span>
            )}
          </span>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
